"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MawidFirstResponse_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var MawidFirstResponse_Factory = /** @class */ (function () {
    function MawidFirstResponse_Factory() {
    }
    MawidFirstResponse_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CASAppId: model.CASAppId,
            HISAppId: model.HISAppId,
            HISSlotID: model.HISSlotID,
        };
        return result;
    };
    MawidFirstResponse_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CASAppId: model.CASAppId,
            HISAppId: model.HISAppId,
            HISSlotID: model.HISSlotID,
        };
        return result;
    };
    return MawidFirstResponse_Factory;
}());
exports.MawidFirstResponse_Factory = MawidFirstResponse_Factory;
